export default "__VITE_ASSET__BbdFEmdy__"